module.exports = __webpack_public_path__ + "img/Trophy Cup Table46.a184c763.jpg";